import { useEffect, useState } from 'react';

export default function BatchesTab() {
    const [batches, setBatches] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const resp = await fetch('/api/inventory/batches', { credentials: 'same-origin' });
                if (resp.ok) {
                    const data = await resp.json();
                    setBatches(data);
                }
            } catch (e) {
                console.error('Erreur chargement lots', e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    if (loading) return <div>Chargement des lots…</div>;

    return (
        <div>
            <h2 className="text-xl font-semibold">Lots d'ingrédients</h2>
            <div className="mt-4">
                {batches.length === 0 && <div>Aucun lot trouvé.</div>}
                <ul className="space-y-3 mt-2">
                    {batches.map((b) => (
                        <li key={b.id} className="p-3 rounded-lg border bg-white shadow-sm">
                            <div className="flex justify-between">
                                <div>
                                    <div className="font-semibold">{b.ingredient?.name || 'Ingrédient'}</div>
                                    <div className="text-sm text-gray-600">Lot: {b.lot_number || '—'}</div>
                                    <div className="text-sm text-gray-600">Quantité restante: {b.remaining_quantity}</div>
                                </div>
                                <div className="text-right text-sm text-gray-500">
                                    <div>Fournisseur: {b.supplier || '—'}</div>
                                    <div>Exp: {b.expiration_date || '—'}</div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
